import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=956879e2&lang=pug"
import script from "./Tag.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tag.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Tag.vue?vue&type=style&index=0&id=956879e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports